import React from 'react';
import './TickerBar.css';

const TickerBar = () => {
  // Average initiation fees by state
  const stateFees = [
    { state: 'CA', fee: 50000 },
    { state: 'NY', fee: 75000 },
    { state: 'FL', fee: 35000 },
    { state: 'TX', fee: 28000 },
    { state: 'IL', fee: 42000 },
    { state: 'MO', fee: 30000 },
    { state: 'AZ', fee: 25000 },
    { state: 'GA', fee: 32000 },
    { state: 'NC', fee: 38000 },
    { state: 'SC', fee: 27000 },
    { state: 'CO', fee: 45000 },
    { state: 'NJ', fee: 65000 },
    { state: 'MA', fee: 55000 },
    { state: 'CT', fee: 48000 },
    { state: 'VA', fee: 35000 },
  ];

  return (
    <div className="ticker-bar">
      <div className="ticker-content">
        {/* First loop */}
        {stateFees.map((item, index) => (
          <div key={`a-${index}`} className="ticker-item">
            <span className="ticker-state">{item.state}</span>
            <span className="ticker-fee">${item.fee.toLocaleString()}</span>
          </div>
        ))}
        {/* Second loop for seamless scroll */}
        {stateFees.map((item, index) => (
          <div key={`b-${index}`} className="ticker-item">
            <span className="ticker-state">{item.state}</span>
            <span className="ticker-fee">${item.fee.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TickerBar;